export default __webpack_public_path__ + "static/media/SD.95702132.svg";